import { Component, Input, OnDestroy, SimpleChanges, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import * as Highcharts from 'highcharts';
import HC_accessibility from 'highcharts/modules/accessibility';
import HC_more from 'highcharts/highcharts-more';
import { HttpClient } from '@angular/common/http';
import { PiechartService } from '../../piechart.service';
import { Observable, Subscription } from 'rxjs';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { ActivatedRoute, Router } from '@angular/router';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import * as _ from 'lodash';
import { SignificanceService } from 'src/app/common/services/significance.service';

// Initialize Highcharts modules
HC_more(Highcharts);
HC_accessibility(Highcharts);

// Change vs PY comes as a fraction for percentage metrics (share/respgrp) and as an
// absolute value for mean/index, which must not be scaled.
function getChangeValue(point: any): number {
  return point?.isPercentage ? Number(point?.cov) * 100 : Number(point?.cov);
}



@Component({
  selector: 'app-piechart23',
  templateUrl: './piechart23.component.html',
  styleUrls: ['./piechart23.component.css'],
  host: {'[class.popup-mode]': 'popUp'}
})
export class Piechart23Component implements OnDestroy, AfterViewInit {
constructor(
    private http: HttpClient,
    private piechartservice: PiechartService,
    private _customSnapshotService: CustomsnapshotService,
    private router: Router,
    private route: ActivatedRoute,
    private _configService: SnapshotService,
    private significanceService: SignificanceService,
    private cdr: ChangeDetectorRef
  ) {
  }
  jsondata: any;
  seriescolor: any;
  seriesgradientcolor: any;
  chartproperties: any;
  samplesizeconstant: any;
  chartimagepath: any;
  userselectedchartdata: any;
  chart: any;
    globalColorMapping: Map<string, string> = new Map(); // Store consistent colors for categories
  legendTable: { cohorts: string[]; rows: Array<{ name: string; color: string; values: { [cohort: string]: string } }> } | null = null;
  hiddenLegendMetrics: { [metric: string]: boolean } = {};
  /** Concentric rings supported by the visual. */
  static readonly MAX_RINGS = 6;
  /** Square plot size (px) used in the expanded multi-cohort view; chart + container must match. */
  popupPlotSizePx: number = 250;
  /** Shared y-axis max across multi-cohort polar rings so scales match. */
  sharedAxisMax: number = 100;
  chartRegistry: Map<string, any> = new Map();

  // Popup legend table sizing knobs — change these to tune the visual quickly.
  legendTableMaxWidthPx: number = 980;
  legendHeaderMaxWidthPx: number = 280;
  legendNameMaxWidthPx: number = 300;
  legendDotSizePx: number = 10;
  legendFontSizePx: number = 14;
  legendCellPaddingY: number = 3;
  legendCellPaddingX: number = 10;
  private legendTableClickHandler?: (event: Event) => void;

    // Multi-cohort properties
  cohorts: any[] = [];
  isMultiCohort: boolean = false;
  //parameters from snapshot-chrtparent

  // @Input() gridTempleteColumns: any;
  // @Input() popUpp: any;
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "28em";
  @Input() isOutput: any;
  maxDataPoints: any = Piechart23Component.MAX_RINGS;
  significanceValue: any = "None";
  chartMainData: any = [];
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
 hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
  private subscriptions: Subscription = new Subscription();
  configuredProperties: any;

  ngOnInit(): void {
    if (this.isOutput) {

      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.applyCustomMetricExtensions();
      this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      // Detect multi-cohort BEFORE subscriptions fire updateSig
      this.checkMultiCohort();
      if (!this.isMultiCohort) {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      }
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
         Highcharts.setOptions({
          plotOptions: {
            series: {
                animation: false
            }
        }
});
    }
    else {
      this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties.showLegend = true;
        this.chartproperties.legendPosition = "bottom";
        this.chartproperties.decimalRoundOff = 2;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.chartimagepath = this.piechartservice.chartimagepath;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant
        // this.plotChart('chart-container'+this.id,this.jsondata['data'], this.chartproperties);
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.chartproperties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
      });
    }
  }

   private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['customData'] && !changes['customData'].firstChange) {
    //   this.ngOnInit();
    }
  }

  ngAfterViewInit(): void {
    if (this.isOutput && this.isMultiCohort) {
      setTimeout(() => this.updateSig(), 100);
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/piechart.json').subscribe((data) => {
        this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.jsondata = data[0];
        this.chartproperties = this.jsondata['properties'][0];
        this.chartproperties = this.configuredProperties != undefined ? this.configuredProperties : this.chartproperties;
        this.seriescolor = this.piechartservice.color;
        this.seriesgradientcolor = this.piechartservice.linearGradients1;
        this.samplesizeconstant = this.piechartservice.samplesizeconstant;
         this.chartproperties.datalabelStyle = this.significanceValue == "None" ? "datalabel" : "sigChange";
        this.chartproperties.dataLabelPosition = 'right';
         this.chartproperties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.chartproperties.datalabelStyle;
      //   if (this.hasCustomMetricSignificance) {
      //   this.chartproperties.datalabelStyle = "default";
      // } else {
      //   this.chartproperties.datalabelStyle =
      //     this.significanceValue == "None"
      //       ? "default"
      //       : "sigChange";
      // }

      
      // if (
      //   this._configService.isIndexSelected &&
      //   !this.hasCustomMetricIndex
      // ) {
      //   this.chartproperties.datalabelStyle = "index";
      // }
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        if (this.isMultiCohort) {
          // Build color mapping by metric option (matches legend table + slices)
          this.globalColorMapping.clear();
          let colorIndex = 0;
          const isgradient = this.chartproperties.gradientBarColor;
          const allMetricValues = (this.customData?.metric_value || [])
            .filter((mv: any) => !mv.isInnerCircle)
            .slice()
            .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0));

          allMetricValues.forEach((mv: any) => {
            const seriesName = mv.option;
            if (seriesName && !this.globalColorMapping.has(seriesName)) {
              // Colours on the data are keyed by cohort, so every metric of a cohort carries the
              // same one. Rings represent metrics here, so take the palette in metric order instead.
              this.globalColorMapping.set(seriesName, this.getPaletteColor(colorIndex, isgradient));
              colorIndex++;
            }
          });

          // Wait for *ngFor chart containers, then plot one chart per cohort
          setTimeout(() => {
            this.buildLegendTable(this.customData);
            this.computeSharedAxisMax();
            this.cdr.detectChanges();
            this.cohorts.forEach((cohort, index) => {
              this.plotChart(
                'chart-container' + this.id + '-' + index,
                this.jsondata['data'],
                this.chartproperties,
                cohort
              );
            });
            setTimeout(() => this.renderLegendTable(), 0);
          }, 0);
        } else {
          this.legendTable = null;
          this.renderLegendTable();
          this.plotChart(
            'chart-container' + this.id,
            this.jsondata['data'],
            this.chartproperties
          );
        }
      });
  }
customization(): Observable<any> {
 const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
    return _.cloneDeep(this._customSnapshotService.getChartCustomization("09/Pie Chart", snapshotTypeSelectedName, cohortType));
  }

  private getCohortKeyFromColChild(colChild: string): string {
    const parts = (colChild || '').split('|').map((p: string) => p.trim()).filter(Boolean);
    if (!parts.length) return '';
    return parts[parts.length - 1];
  }

  private formatLegendValue(entry: any): string {
    if (!entry || entry.data == null || entry.data === 'NA') {
      return 'NA';
    }

    const calcType = String(entry.CalculationType || '').toLowerCase();
    const isPercentage = calcType === 'share' || calcType === 'respgrp';
    const numeric = Number(entry.data);

    if (Number.isNaN(numeric)) {
      return String(entry.data);
    }

    const value = isPercentage ? numeric * 100 : numeric;
    const decimalPlaces = Number.isFinite(Number(this.chartproperties?.decimalRoundOff))
      ? Number(this.chartproperties.decimalRoundOff)
      : 2;
    // Keep the same rounding as the slices, without forced trailing zeros
    const formatted = decimalPlaces === 0
      ? `${Math.round(value)}`
      : `${parseFloat(value.toFixed(decimalPlaces))}`;
    return `${formatted}${isPercentage ? '%' : ''}`;
  }

  /**
   * Legend table cell for the expanded multi-cohort view. Mirrors the slice data labels so the
   * table shows index / change vs PY with the same colouring and LS/IS handling.
   */
  private buildLegendCellHtml(entry: any): string {
    const valueText = this.formatLegendValue(entry);
    if (!entry || valueText === 'NA') {
      return 'NA';
    }

    const configService = this._configService;
    const calcType = String(entry.CalculationType || '').toLowerCase();
    const isPercentage = calcType === 'share' || calcType === 'respgrp';
    const sampleSize = Number(entry.baseValueforLSorIs);
    const text = configService.CheckLSorIScondition(configService.userRole, valueText, sampleSize);
    const style = this.chartproperties?.datalabelStyle;

    if (text === 'I/S') {
      return text;
    }

    if (style === 'index') {
      let indexText = (entry.data2 == null || entry.data2 === 'NA' || Number(entry.data2) === -1)
        ? 'NA'
        : Number(entry.data2).toFixed(1);
      indexText = configService.CheckLSorIScondition(configService.userRole, indexText, sampleSize);
      const indexColor = configService.CheckIndexColoring(indexText);
      return `${text}<span style="color:${indexColor};font-size:0.85em;"> (${indexText})</span>`;
    }

    if (style === 'sigChange') {
      if (entry.changeVsPY == null || entry.changeVsPY === 'NA') {
        return `${text}<span style="color:black;font-size:0.85em;"> (NA)</span>`;
      }
      const changeVal = isPercentage ? Number(entry.changeVsPY) * 100 : Number(entry.changeVsPY);
      const sigClass = (entry.Significance_Value < this.Sig_LowerLimt || changeVal < 0)
        ? 'red'
        : 'black';
      const changeText = `${parseFloat(changeVal.toFixed(1))}${isPercentage ? '%' : ''}`;
      return `${text}<span style="color:${sigClass};font-size:0.85em;"> (${changeText})</span>`;
    }

    return text;
  }

  /** Legend dots need a plain CSS colour, while the rings may be a Highcharts gradient object. */
  private toSolidColor(color: any): string {
    if (typeof color === 'string') return color;
    const firstStop = color?.stops?.[0]?.[1];
    return typeof firstStop === 'string' ? firstStop : '#aaaaaa';
  }

  private getPaletteColor(index: number, isgradient: boolean): any {
    const palette = (isgradient ? this.seriesgradientcolor : this.seriescolor) || [];
    if (!palette.length) return '#aaaaaa';
    return palette[index % palette.length];
  }

  private getMaxRingCount(): number {
    const configured = Number(this.maxDataPoints);
    if (Number.isFinite(configured) && configured > 0) {
      return Math.min(configured, Piechart23Component.MAX_RINGS);
    }
    return Piechart23Component.MAX_RINGS;
  }

  private computeSharedAxisMax(): void {
    let dataMax = 0;
    const maxRings = this.getMaxRingCount();
    const metrics = (this.customData?.metric_value || [])
      .filter((mv: any) => !mv.isInnerCircle)
      .slice()
      .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0))
      .slice(0, maxRings);

    metrics.forEach((mv: any) => {
      (mv.data || []).forEach((entry: any) => {
        if (entry?.data == null || entry.data === 'NA') return;
        const calcType = String(entry.CalculationType || '').toLowerCase();
        const numeric = Number(entry.data);
        if (!Number.isFinite(numeric)) return;
        const value = (calcType === 'share' || calcType === 'respgrp') ? numeric * 100 : numeric;
        dataMax = Math.max(dataMax, value);
      });
    });

    this.sharedAxisMax = Math.max(100, Math.ceil(dataMax));
  }

  private buildLegendTable(sourceData: any): void {
    if (!this.isMultiCohort || !this.popUp) {
      this.legendTable = null;
      return;
    }

    const maxRings = this.getMaxRingCount();
    const metricValues = (sourceData?.metric_value || [])
      .filter((mv: any) => !mv.isInnerCircle)
      .slice()
      .sort((a: any, b: any) => (a.selectorder ?? 0) - (b.selectorder ?? 0))
      .slice(0, maxRings);
    if (!metricValues.length) {
      this.legendTable = null;
      return;
    }

    const cohorts = this.cohorts.map((c: any) => c.title).filter((c: string) => !!c);
    if (cohorts.length < 2) {
      this.legendTable = null;
      return;
    }

    const rows = metricValues.map((mv: any, index: number) => {
      const name = mv.option || '';
      // mv.data[].color is the cohort colour, so it must not be used as a per-metric fallback.
      const color = this.toSolidColor(
        this.globalColorMapping.get(name)
          || this.getPaletteColor(index, !!this.chartproperties?.gradientBarColor)
      );

      const values: { [cohort: string]: string } = {};
      cohorts.forEach((cohort: string) => {
        // Must use the same cohort key rules as checkMultiCohort (not only the last | segment)
        const entry = (mv.data || []).find((d: any) => this.getCohortKeyFromColChild(d.colChild) === cohort);
        values[cohort] = this.buildLegendCellHtml(entry);
      });

      return { name, color, values };
    });

    this.legendTable = { cohorts, rows };
  }

  private escapeHtml(value: any): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  private truncateLegendName(name: string, maxChars: number = 30): string {
    if (!name) return '';
    return name.length > maxChars ? `${name.slice(0, maxChars)}...` : name;
  }

  private renderLegendTable(): void {
    const container = document.getElementById('popup-legend-table-container-' + this.id);
    if (!container) {
      return;
    }

    if (this.legendTableClickHandler) {
      container.removeEventListener('click', this.legendTableClickHandler);
      this.legendTableClickHandler = undefined;
    }

    if (!this.popUp || !this.isMultiCohort || !this.legendTable || !this.legendTable.rows?.length) {
      container.innerHTML = '';
      return;
    }

    // Label column + one column per cohort, so values line up under their charts
    const labelColWidth = 26;
    const cohortColWidth = (100 - labelColWidth) / Math.max(1, this.legendTable.cohorts.length);
    const headerHtml = this.legendTable.cohorts
      .map((cohort) => `
        <th title="${this.escapeHtml(cohort)}" style="padding:${this.legendCellPaddingY}px ${this.legendCellPaddingX}px;text-align:center;font-weight:700;white-space:normal;line-height:1.2;width:${cohortColWidth}%;vertical-align:bottom;">
          ${this.escapeHtml(cohort)}
        </th>
      `)
      .join('');

    const bodyHtml = this.legendTable.rows
      .map((row) => {
        const isHidden = !!this.hiddenLegendMetrics[row.name];
        const rowOpacity = isHidden ? '0.45' : '1';
        const legendLabel = this.truncateLegendName(row.name, 36);
        const valueCells = this.legendTable!.cohorts
          .map((cohort) => `<td style="padding:${this.legendCellPaddingY}px ${this.legendCellPaddingX}px;text-align:center;white-space:nowrap;width:${cohortColWidth}%;">${row.values[cohort] ?? 'NA'}</td>`)
          .join('');

        return `
          <tr data-legend-name="${this.escapeHtml(row.name)}" style="cursor:pointer;opacity:${rowOpacity};">
            <td style="padding:${this.legendCellPaddingY}px ${this.legendCellPaddingX}px;text-align:left;white-space:nowrap;width:${labelColWidth}%;">
              <span style="display:inline-block;width:${this.legendDotSizePx}px;height:${this.legendDotSizePx}px;border-radius:50%;background:${this.escapeHtml(row.color || '#aaaaaa')};margin-right:7px;vertical-align:middle;"></span>
              <span title="${this.escapeHtml(row.name)}" style="display:inline-block;max-width:${this.legendNameMaxWidthPx}px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;vertical-align:middle;">${this.escapeHtml(legendLabel)}</span>
            </td>
            ${valueCells}
          </tr>
        `;
      })
      .join('');

    container.innerHTML = `
      <table class="popup-legend-table" style="border-collapse:collapse;table-layout:fixed;width:100%;font-size:${this.legendFontSizePx}px;">
        <thead>
          <tr>
            <th style="padding:${this.legendCellPaddingY}px ${this.legendCellPaddingX}px;width:${labelColWidth}%;"></th>
            ${headerHtml}
          </tr>
        </thead>
        <tbody>
          ${bodyHtml}
        </tbody>
      </table>
    `;

    this.legendTableClickHandler = (event: Event) => {
      const target = event.target as HTMLElement | null;
      const row = target?.closest('tr[data-legend-name]') as HTMLElement | null;
      if (!row) return;
      const rawName = row.getAttribute('data-legend-name');
      if (!rawName) return;
      const metricName = rawName
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
      this.toggleLegendMetric(metricName);
    };
    container.addEventListener('click', this.legendTableClickHandler);
  }

  private toggleLegendMetric(metricName: string): void {
    const nextHiddenState = !this.hiddenLegendMetrics[metricName];
    this.hiddenLegendMetrics = { ...this.hiddenLegendMetrics, [metricName]: nextHiddenState };
    this.applyLegendVisibilityToCharts(metricName, !nextHiddenState);
    this.renderLegendTable();
    this.cdr.detectChanges();
  }

  private applyLegendVisibilityToCharts(metricName: string, visible: boolean): void {
    this.chartRegistry.forEach((chartRef: any) => {
      if (!chartRef || !chartRef.series) return;
      chartRef.series.forEach((seriesRef: any) => {
        if (seriesRef && seriesRef.name === metricName) {
          seriesRef.setVisible(visible, false);
        }
      });
      chartRef.redraw();
    });
  }
  seriesdata: any;
  cov: any;
  significance: any;
  significance2: any;
  samplesize: any;
  label: any;
  datalength: number = 0;

  checkMultiCohort(): void {
    // Always reset first so state does not leak across snapshot switches.
    this.isMultiCohort = false;
    this.cohorts = [];

    const snapshotType = String(this._configService.selectedSnapshotType || '').toLowerCase();
    const isAudienceSnapshot = snapshotType.includes('audience');
    const isAudienceMultiCohort = this._configService.multiCohort
      || this._configService.outputSnapshotData?.audienceCohortType === 'multiple';

    if (isAudienceSnapshot && isAudienceMultiCohort) {
      
      const metricValues = this.customData.metric_value;
      
      // Extract unique cohorts from colChild in the data array
      const cohortSet = new Set<string>();
      
      // Parse through all metric values to find unique cohorts
      metricValues.forEach((mv: any) => {
        if (mv.data && mv.data.length > 0) {
          mv.data.forEach((dataItem: any) => {
            if (dataItem.colChild) {
              // Extract cohort name from colChild (e.g., "Audience|Gender|Male" -> "Male")
              const parts = dataItem.colChild.split('|');
              if (parts.length > 0) {
                const cohortName = this.getCohortKeyFromColChild(dataItem.colChild);
                cohortSet.add(cohortName);
              }
            }
          });
        }
      });
      
      const uniqueCohorts = Array.from(cohortSet);
      
      // If we have multiple cohorts, enable multi-cohort mode
      if (uniqueCohorts.length > 1) {
        this.isMultiCohort = true;
        
        // Create cohort data structure
        this.cohorts = uniqueCohorts.map(cohortName => {
          return {
            title: cohortName,
            metric_value: metricValues.map((mv: any) => {
              return {
                ...mv,
                data: mv.data.filter((d: any) => {
                  const itemCohort = this.getCohortKeyFromColChild(d.colChild);
                  return itemCohort === cohortName;
                })
              };
            }).filter((mv: any) => mv.data.length > 0) // Only include metric_values that have data for this cohort
          };
        });
        
      }
    }
  }
  preparemainChartData(data: any) {
    this.chartMainData = [];
    // this.chartproperties=this.configuredProperties!=undefined?this.configuredProperties:this.chartproperties;

    if (this._configService.selectedSnapshotType.toLowerCase().includes('multi')) {

      data.metric_value.forEach((lev2: any) => {
        const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || false;
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": this.isMultiCohort
              ? lev2.option
              : (dataArr.colChild.split("|").length>1?dataArr.colChild.split("|")[1]:dataArr.colChild),
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": (dataArr.data == null) ? "NA" : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        })
      })
    }
    else {
      let i = 0;
      data.metric_value.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev2.option,
            "Category Name": lev2.metric_group,
            "Rounded Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": (dataArr.data == null) ? "NA" : (dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data)),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" || dataArr.CalculationType?.toLowerCase() == "meanpercentage" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value,
            "color": dataArr.color,
            "colorLinearGradient": dataArr.colorLinearGradient
          }
          this.chartMainData.push(d1);
        });
      });
    }

  }


  preparechartdata(data: any, islowsample: any, isgradient: any) {
    if (this.isOutput) {
      let seriesdata: any[] = [];
      let cov: any = [];
      let significance: any = [];
      let samplesize: any = [];
      let label: any = [];
      let innerSize = 40;
      let size = 35;
      let d: any = {};
      const usedRingColors = new Set<string>();
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      data.forEach((dat: any) => {

        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        let value = isNaN(parseFloat(dat['Value'])) || parseFloat(dat['Value']) == null ? null : parseFloat(Number(dat['Value']).toFixed(this.chartproperties.decimalRoundOff));
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        
        if (finalvalue !== null && finalvalue < 0) { return; }
        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;
        
        if (this.isMultiCohort) {
          // Ignore dat['color']: it is the cohort colour, which would paint every ring of a
          // cohort the same. Each metric keeps its own palette colour across all cohorts.
          if (this.globalColorMapping.has(seriesName)) {
            assignedColor = this.globalColorMapping.get(seriesName)!;
          } else {
            assignedColor = this.getPaletteColor(this.globalColorMapping.size, isgradient);
            this.globalColorMapping.set(seriesName, assignedColor);
          }
        } else {
          // Single brand: dat['color'] is the brand colour, so every ring would match.
          // Keep a colour the first time it appears, and give the next ring the next palette colour.
          const explicitColor = !isgradient ? dat['color'] : (dat['colorLinearGradient'] || dat['color']);
          const explicitKey = typeof explicitColor === 'string' ? explicitColor : '';
          if (explicitKey && !usedRingColors.has(explicitKey)) {
            assignedColor = explicitColor;
            usedRingColors.add(explicitKey);
          } else {
            let paletteIndex = usedRingColors.size;
            assignedColor = this.getPaletteColor(paletteIndex, isgradient);
            let guard = 0;
            while (typeof assignedColor === 'string' && usedRingColors.has(assignedColor) && guard < 20) {
              paletteIndex++;
              assignedColor = this.getPaletteColor(paletteIndex, isgradient);
              guard++;
            }
            usedRingColors.add(typeof assignedColor === 'string' ? assignedColor : ('gradient-' + paletteIndex));
          }
        }
        
        let m = {
          name: dat['Series Name'],
          y: (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          indexValue: (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (dat['ValueForIndex'] == null ? 0 : dat['ValueForIndex'])),
          actualIndexValue: dat['ActualIndexValue'],
          y1: this._configService.isIndexSelected ? finalvalue : (Number(dat['Sample size']) <= this._configService.ISthreshold ? 0 : (finalvalue == null ? 0 : finalvalue)),
          
          legendkeycolor: assignedColor,
          actualcolor: assignedColor,
          color: assignedColor,

          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: "",
          isPercentage: dat["isPercentage"],
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: dat["Significance_Value"]
        }
        
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.label = label;
      this.samplesize = samplesize;
      this.seriesdata = seriesdata;

    }
    else {
      let seriesdata: any[] = [];
      let d: any = {};
      let cov: any = [];
      let significance: any = [];
      let significance2: any = [];
      let samplesize: any = [];
      let label: any = [];
      let i = 0;
      d.animation = this.piechartservice.allowAnimation;
      d.data = [];
      data.forEach((dat: any) => {
        cov.push(dat['Change value vs PY']);
        significance.push(dat['Significance']);
        significance2.push(dat['Significance2']);
        label.push(dat['Label']);
        samplesize.push(dat['Sample size'])
        d.name = dat['Category Name'];
        let value = isNaN(parseFloat(dat['Rounded Value'])) || parseFloat(dat['Rounded Value']) == null ? null : Number(parseFloat(dat['Value']).toFixed(this.chartproperties.decimalRoundOff))
        let finalvalue = !islowsample ? value : (parseFloat(dat['Sample size']) > this.samplesizeconstant ? value : 0)
        
        // For multi-cohort, ensure consistent colors across cohorts
        const seriesName = dat['Series Name'];
        let assignedColor: string;
        
        if (this.isMultiCohort) {
          // Check if this series already has a color assigned
          if (!this.globalColorMapping.has(seriesName)) {
            // Assign a new color from the palette
            const colorIndex = this.globalColorMapping.size;
            assignedColor = !isgradient ? this.seriescolor[colorIndex] : this.seriesgradientcolor[colorIndex];
            this.globalColorMapping.set(seriesName, assignedColor);
          } else {
            // Use the already assigned color
            assignedColor = this.globalColorMapping.get(seriesName)!;
          }
        } else {
          // Single cohort mode - use existing logic
          assignedColor = !isgradient ? this.seriescolor[i++] : this.seriesgradientcolor[i++];
        }
        
        let m = {
          name: dat['Series Name'],
          y: finalvalue == null ? 0 : finalvalue,
          y1: finalvalue,
          actualcolor: assignedColor,
          color: assignedColor,
          cov: dat['Change value vs PY'],
          significance: dat['Significance'],
          significance2: dat['Significance2'],
          samplesize: dat['Sample size'],
          tooltip: ""
        };
        d.data.push(m);
        this.datalength++;
      });
      seriesdata = [d];
      d = {};
      this.cov = cov;
      this.significance = significance;
      this.significance2 = significance2;
      this.label = label;
      this.samplesize = samplesize
      this.seriesdata = seriesdata;
    }
  }


 applycustomization(event: any, item: string) {
    //choose the appropriate customization
    this.piechartservice.applycustomization(event, item, this.chartproperties)
    this.plotChart('chart-container' + this.id, this.jsondata['data'], this.chartproperties);
  }

  userselectedproperties() {
    // this.jsondata['data']=this.jsondata['data'].slice(0,10);
    this.jsondata['properties'][0] = this.chartproperties;
    return JSON.stringify(this.jsondata).toString();
  }

  // Helper method for data label formatting
  formatDataLabel(pointWithMetric: any, chartproperties: any, configService: any, samplesizeconstant: any): string {
    if (!this.isOutput) {
        return pointWithMetric.y || '';
    }

    chartproperties.dataLabelFormat = pointWithMetric.isPercentage;

    if (chartproperties.datalabelStyle == 'datalabel') {
        let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
        return configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
    }

    if (chartproperties.datalabelStyle === "index") {
        let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
        text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
        let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
        if (text2 == "-1" || text2 == -1) {
            text2 = "NA";
        }
        text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));
        return text + "(" + text2 + ")";
    }

    if (chartproperties.datalabelStyle === 'sigChange') {
        let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
        let changeVal = getChangeValue(pointWithMetric);
        if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
            return textCheck + (chartproperties.dataLabelFormat ? '%' : '') + (textCheck != 'I/S' ? ' (NA)' : '');
        } else {
            return textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + (textCheck != 'I/S' ? (' (' + (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA') + ')') : '');
        }
    }

    // Add other formatting styles as needed...
    return pointWithMetric.y || '';
  }



plotChart(containerId: any, jsondata: any, chartproperties: any,cohortData?: any) {
    const popUpState = this.popUp;
    const componentId = this.id;
    const isOutputFlag = this.isOutput; // Capture isOutput flag for use in formatter
    let chartProperties=this.chartproperties;
    localStorage.setItem("properties", JSON.stringify(this.chartproperties));
    let height = this.height;

    let samplesizeconstant = this.samplesizeconstant;
    let chartimagepath = this.chartimagepath;
    let c = 0;
    // Prepare chart data first
    if (this.isOutput) {
            const dataToUse = cohortData ? cohortData : this.customData;
        this.preparemainChartData(dataToUse);
        this.chartMainData = this.chartMainData.filter((item: any) => item['Label'] !== 'NA' && item['Label'] !== null);
        // Deduplicate by series name: a pie chart should have at most one slice per series name.
        const _seenSeriesNames = new Set<string>();
        this.chartMainData = this.chartMainData.filter((item: any) => {
          if (_seenSeriesNames.has(item['Series Name'])) return false;
          _seenSeriesNames.add(item['Series Name']);
          return true;
        });
        // Polar rings: widget shows 2, expanded supports up to 6
        const maxPoints = this.getMaxRingCount();
        this.chartMainData = this.chartMainData.slice(0, maxPoints);
        this.preparechartdata(this.chartMainData, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);

        if (!this.seriesdata || !this.seriesdata[0]?.data?.length) {
          const containerEl = document.getElementById(containerId);
          if (containerEl) {
            containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
          }
          return;
        }
    } else {

        this.preparechartdata(jsondata, chartproperties.datalabelStyle == 'ls', chartproperties.gradientBarColor);
    }

    const configService = this._configService;

    // Extract categories from this.seriesdata
    const categories = this.seriesdata[0].data.map((item: any, index: number) => ({
        name: item.name,
        value: item.y,
        color: item.actualcolor || item.color,
        cov: item.cov,
        significance: item.significance,
        significance2: item.significance2,
        samplesize: item.samplesize,
        tooltip: item.tooltip,
        isPercentage: item.isPercentage,
        Sig_LowerLimt: item.Sig_LowerLimt,
        Sig_UpperLimt: item.Sig_UpperLimt,
        Significance_Value: item.Significance_Value,
        indexValue: item.indexValue,
        actualIndexValue: item.actualIndexValue,
        y1: item.y1
    }));

    // Means/indexes can exceed 100 (e.g. 106). Keep grey track + colored arc on a shared scale.
    const localDataMax = categories.reduce((max: number, cat: any) => {
      const n = Number(cat.value);
      return Number.isFinite(n) ? Math.max(max, n) : max;
    }, 0);
    const axisMax = (this.isMultiCohort && this.popUp)
      ? Math.max(this.sharedAxisMax || 100, Math.ceil(localDataMax))
      : Math.max(100, Math.ceil(localDataMax));

  const series: any[] = [
    {
        // Grey background arcs (remaining to axisMax)
        type: 'column',
        data: categories.map((cat: any) => Math.max(0, axisMax - (cat.value ?? 0))),
        color: '#e0e0e0',
        enableMouseTracking: false,
        showInLegend: false,
        zIndex: -999,
        dataLabels: {
            enabled: false
        }
    }
];

    // Add a separate series for each category to show in legend
    categories.forEach((category:any, index:any) => {
        const data = new Array(categories.length).fill(null);
        // Create a data point with all the necessary properties
        data[index] = {
            y: category.value,
            name: category.name,
            color: category.color,
            cov: category.cov,
            significance: category.significance,
            significance2: category.significance2,
            samplesize: category.samplesize,
            tooltip: category.tooltip,
            isPercentage: category.isPercentage,
            Sig_LowerLimt: category.Sig_LowerLimt,
            Sig_UpperLimt: category.Sig_UpperLimt,
            Significance_Value: category.Significance_Value,
            indexValue: category.indexValue,
            actualIndexValue: category.actualIndexValue,
            y1: category.y1
        };

        series.push({
            type: 'column',
            name: category.name,
            data: data,
            color: category.color,
            zIndex: 2,
            visible: !this.hiddenLegendMetrics[category.name],
            showInLegend: !(popUpState && this.isMultiCohort),
        });
    });

    const chartOptions: Highcharts.Options = {
        chart: {
            type: 'column',
            inverted: true,
            polar: true,
            // Square plot in multi-cohort expand so the rings stay full circles
            height: !isOutputFlag
              ? 400
              : (this.isMultiCohort
                ? (popUpState ? this.popupPlotSizePx : null)
                // Highcharts resolves percentage heights against chart width, not the
                // container height. Let it read the popup container's actual height.
                : null),
            marginTop: !isOutputFlag ? 0 : (this.isMultiCohort ? 0 : (popUpState ? 16 : 0)),
            marginBottom: this.isMultiCohort
              ? 0
              : (popUpState ? 70 : (!isOutputFlag ? 50 : chartproperties.legendPosition == "bottom" ? 40 : 0)),
            backgroundColor: chartproperties.darkTheme ? '#000' : '#fff',
            marginLeft: this.isMultiCohort
              ? 0
              : (chartproperties.legendPosition == 'right' ?
                (popUpState ? -500 : -100) :
                (chartproperties.legendPosition == 'left' ? (popUpState ? 200 : 150) : 0)),
            marginRight: this.isMultiCohort
              ? 0
              : (chartproperties.legendPosition == 'left' ?
                (popUpState ? -30 : -100) :
                (chartproperties.legendPosition == 'right' ? (popUpState ? 160 : 140) : 0)),
            spacing: this.isMultiCohort ? [0, 0, 0, 0] : (popUpState ? [0, 2, 5, 2] : [0, 0, 0, 0]),
//             events: {
//                 render: function() {
//                     const chart = this;
//                     const centerX = chart.plotWidth / 2 + chart.plotLeft;
//                     const centerY = chart.plotHeight / 2 + chart.plotTop;

//                     // Clean up old connectors
//                     if ((chart as any).customConnectors) {
//                         (chart as any).customConnectors.forEach((el: any) => el.destroy());
//                     }
//                     (chart as any).customConnectors = [];

//                     // Set leftX to 1000 when popup is true, otherwise use the existing logic
//                     const leftX = (popUpState === true) ?chart.plotLeft + 1000 : (chart.plotLeft + (chartproperties.legendPosition == 'right' ? 330 : 300));

//                     // Collect all label positions first, maintaining original order
//                     const labelData: any[] = [];

//                     // Process only the data series (skip the background series at index 0)
//                     chart.series.forEach((series: any, seriesIndex: number) => {
//                         if (seriesIndex === 0) return; // Skip background series

//                         series.points.forEach((point: any) => {
//                             if (!point.graphic || point.y === null || point.y === 0) return;

//                             const shape = point.shapeArgs;
//                             if (!shape) return;

//                             // Mid angle of arc
//                             const angleRad = (shape.start + shape.end) / 2;

//                             // Calculate the actual outer radius where the data bar ends
//                             const outerRadius = shape.r;

//                             // Point at outer edge of the actual data bar
//                             const x1 = centerX + Math.cos(angleRad) * outerRadius;
//                             const y1 = centerY + Math.sin(angleRad) * outerRadius;

//                             labelData.push({
//                                 point: point,
//                                 x1: x1,
//                                 y1: y1,
//                                 originalY: y1,
//                                 labelValue: point.y,
//                                 angleRad: angleRad,
//                                 seriesIndex: seriesIndex
//                             });
//                         });
//                     });

//                     // Sort by y1 (vertical position) to reduce criss-cross of connectors
//                     labelData.sort((a, b) => a.y1 - b.y1);

//                     // Position labels vertically aligned near the right area (marked zone)
//                     const rightX = chart.plotLeft + chart.plotWidth + 10; // Distance from chart center
//                     const startY = centerY - (labelData.length * 12); // Center align vertically
//                     const verticalSpacing = 22; // Spacing between labels

//                     labelData.forEach((data, i) => {
//                         data.adjustedY = startY + i * verticalSpacing;
//                         data.adjustedX = rightX; // Fixed X position for all labels
//                     });

//                     // labelData.forEach((data, index) => {
//                     //     data.adjustedY = topYStart + index * labelSpacing;
//                     // });

//                     // Draw connectors and labels with adjusted positions, maintaining original order
//                     labelData.forEach((data) => {
//                         const { point, x1, y1, labelValue, adjustedY } = data;

//                         // Get the formatted label text using the same logic as data labels
//                         let formattedLabelText = labelValue;
//                         let labelColor = chartproperties.darkTheme ? '#fff' : '#000';

//                         if (isOutputFlag) {
//                             // Create point with metric data for formatting
//                             const pointWithMetric = {
//                                 name: point.name,
//                                 color: point.color,
//                                 y: point.y,
//                                 y1: point.y1,
//                                 cov: point.cov,
//                                 significance: point.significance,
//                                 samplesize: point.samplesize,
//                                 significance2: point.significance2,
//                                 tooltip: point.tooltip,
//                                 isPercentage: point.isPercentage,
//                                 Sig_LowerLimt: point.Sig_LowerLimt,
//                                 Sig_UpperLimt: point.Sig_UpperLimt,
//                                 Significance_Value: point.Significance_Value,
//                                 indexValue: point.indexValue,
//                                 actualIndexValue: point.actualIndexValue
//                             };

//                             chartproperties.dataLabelFormat = pointWithMetric.isPercentage;

//                             if (chartproperties.datalabelStyle == 'datalabel') {
//                                 let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
//                                 formattedLabelText = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
//                             }
//                             else if (chartproperties.datalabelStyle === "index") {
//                                 let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
//                                 text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
//                                 let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
//                                 if (text2 == "-1" || text2 == -1) {
//                                     text2 = "NA";
//                                 }
//                                 text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));
//                                 let color = configService.CheckIndexColoring(String(text2));
//                                 formattedLabelText = text + "(" + text2 + ")";
//                             }
//                             else if (chartproperties.datalabelStyle === 'sigChange') {
//                                 let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
//                                 let changeVal = Number(pointWithMetric.cov) * 100;
//                                 if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
//                                     formattedLabelText = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' (NA)';
//                                 } else {
//                                     let sigClass = (pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt || Number(changeVal) < 0) ? 'red' : 'black';
//                                     formattedLabelText = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' (' + (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA') + ')';
//                                     labelColor = sigClass;
//                                 }
//                             }
//                             else if (chartproperties.datalabelStyle === 'change') {
//                                 formattedLabelText = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' (' + Number(pointWithMetric.cov) * 100 + ')' : 'NA';
//                             }
//                             else if (chartproperties.datalabelStyle === 'significance + changeVs') {
//                                 const upwardTriangle = '\u25B2';
//                                 const downwardTriangle = '\u25BC';
//                                 let sig = Number(pointWithMetric.significance);
//                                 let s = sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
//                                 formattedLabelText = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' (' + Number(pointWithMetric.cov) * 100 + ')' + s : 'NA';
//                             }
//                             else if (chartproperties.datalabelStyle == 'significance') {
//                                 const upwardTriangle = '\u25B2';
//                                 const downwardTriangle = '\u25BC';
//                                 let sig = pointWithMetric.significance;
//                                 let s = Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
//                                 formattedLabelText = pointWithMetric.y != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + s) : 'NA';
//                             }
//                             else if (chartproperties.datalabelStyle == 'ls') {
//                                 formattedLabelText = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
//                             }
//                             else if (chartproperties.datalabelStyle == "significance2") {
//                                 const upwardTriangle = '\u25B2';
//                                 const downwardTriangle = '\u25BC';
//                                 let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
//                                 let changeValue = Number(pointWithMetric.cov) * 100;
//                                 let changeText = changeValue.toString();
//                                 let sig = pointWithMetric.significance;
//                                 let sig1 = pointWithMetric.significance2;
//                                 let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
//                                 let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
//                                 let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));
//                                 if (changeValue > 0) {
//                                     changeText = "+" + changeText;
//                                 }
//                                 formattedLabelText = text + (pointWithMetric.y != null && changeText ? ' (' + changeText + ') ' + s : '');
//                             }

//                             // If the label contains parentheses, make the content inside () smaller font size
//                             if (typeof formattedLabelText === 'string' && formattedLabelText.includes('(') && formattedLabelText.includes(')')) {
//                                 formattedLabelText = formattedLabelText.replace(/\(([^)]+)\)/g, '<span style="font-size:0.75em;">($1)</span>');
//                             }
//                         }

//                        // Reduce connector length by shifting end point closer to the chart
// const connectorLengthReduction = !isOutputFlag?200:(popUpState === true && chartproperties.legendPosition === 'right') ? 600 :
//     (popUpState === true && chartproperties.legendPosition === 'left') ? 300 :
//     (chartproperties.legendPosition === 'right' ? 150 : 80); // 200 if popup and right, 100 if popup and left, else 150 or 100
// const x2 = data.adjustedX - connectorLengthReduction;
// const y2 = data.adjustedY;


//                         // Draw connector line from bar edge to label (may be angled if position was adjusted)
//                         const path = chart.renderer.path(['M', x1.toString(), y1.toString(), 'L', x2.toString(), adjustedY.toString()] as any)
//                             .attr({
//                                 stroke: point.color,
//                                 'stroke-width': 1.4,
//                                 zIndex: 10
//                             })
//                             .add();
//                         (chart as any).customConnectors.push(path);

//                         // Draw label at adjusted position with formatted text and color
//                         const label = chart.renderer.text(formattedLabelText, x2 + 5, adjustedY + 4)
//                             .css({
//                                 color: labelColor,
//                                 fontSize: '12px',
//                                 fontWeight: 'bold',
//                                 fontFamily: 'KantarBrown-Regular',
//                                 textAnchor: 'start'
//                             })
//                             .add();
//                         (chart as any).customConnectors.push(label);
//                     });
//                 }
//             }
        },
        pane: {
            size: this.isMultiCohort ? (popUpState ? '100%' : '80%') : '85%',
            // Smaller hub as ring count grows, so 6 rings still get usable thickness
            innerSize: this.isMultiCohort
              ? (categories.length >= 6 ? '14%'
                : categories.length >= 5 ? '18%'
                : categories.length >= 4 ? '22%'
                : categories.length >= 3 ? '26%'
                : '32%')
              : '20%'
        },
        title: {
            text: ''
        },
        credits: {
            enabled: false
        },
        legend: {
          enabled: !this.isMultiCohort,
            itemStyle: {
                color: '#333',
                fontWeight: 'normal',
        fontSize: popUpState ? '1.1em' : '1em', // Larger font when popup is true
         fontFamily: 'KantarBrown-Regular'
    },
    navigation: {
        activeColor: '#7f7f7f',
        animation: true,
        arrowSize: 12,
        inactiveColor: '#ccc',
        enabled: true, // Always enable navigation arrows
        style: {
            fontSize: '0.8em',
            color: chartproperties.darkTheme ? 'white' : '#333',
        }
    },
    maxHeight: popUpState ? 120 : chartproperties.legendPosition === 'bottom' ?50:200, // Increased height when popup is true
    layout: chartproperties.legendPosition == 'bottom' ? 'horizontal' : 'vertical',
    x: chartproperties.legendPosition == 'right' ?
        (popUpState ? 10 : 10) : // Keep legend position normal for right
        (chartproperties.legendPosition == 'left' ?
            (popUpState ? 30 : -10) : // Move legend more left for left position
            20),
    y: chartproperties.legendPosition == 'bottom' ?
        (popUpState ? 20 : 0) : 0, 
 
    itemMarginBottom: popUpState ? 7 : 2, // More bottom margin when popup is true
    itemWidth: popUpState ? 400 : chartproperties.legendPosition === 'bottom' ?200: 200, // Wider items when popup is true
    align: chartproperties.legendPosition,
    verticalAlign: chartproperties.legendPosition != 'bottom' ? 'middle' : 'bottom',
    symbolWidth: 0,
    symbolHeight: 0,
    useHTML: true,

    labelFormatter: function(this: any): any {
        let point = this as any;
      const yData = this.yData || [];
    const legendIndex = this.index - 1;
    // categories is available in the closure scope of plotChart
    const category = categories[legendIndex];

    // Fallback if category is not found
    if (!category) return '';

    let textcolor = chartproperties.darkTheme ? 'white' : 'black';
    let legend = '';

    // Build pointWithMetric from the category object
    const pointWithMetric = {
        name: category.name,
        color: category.color,
        y: category.value,
        y1: category.y1,
        cov: category.cov,
        significance: category.significance,
        samplesize: category.samplesize,
        significance2: category.significance2,
        tooltip: category.tooltip,
        isPercentage: category.isPercentage,
        Sig_LowerLimt: category.Sig_LowerLimt,
        Sig_UpperLimt: category.Sig_UpperLimt,
        Significance_Value: category.Significance_Value,
        indexValue: category.indexValue,
        actualIndexValue: category.actualIndexValue
    };
                 

                    if (this.color !== '#eeebed' && this.color != '#7f7f7f') {
                        chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                        let textcolor = chartproperties.darkTheme ? 'white' : 'black';

                        if (chartproperties.datalabelStyle == 'datalabel') {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                            pointWithMetric.tooltip = text;

                           legend=
                                '<span style="color:' + textcolor + ';">' + text + '</span>'
                            ;
                        }

                        if (chartproperties.datalabelStyle === "index") {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                            let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                            if (text2 == "-1" || text2 == -1) {
                                text2 = "NA";
                            }
                            text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                            let color = configService.CheckIndexColoring(String(text2));
                            pointWithMetric.tooltip = text + "(" + text2 + ")";
                            // Smaller font for content inside ()
                           legend=
                                '<span style="font-size:0.95em;color:' + textcolor + ';">' + text + '</span>' +
                                '<span style="color:' + color + ';font-size:0.75em;"> (' + text2 + ')</span>'
                            ;
                        }

                        if (chartproperties.datalabelStyle === 'sigChange') {
                            let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                            let changeVal = getChangeValue(pointWithMetric);
                            if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                                let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + (textCheck != 'I/S' ? ' <span style="color:black;font-size:80%;">(NA)</span>' : '');
                                pointWithMetric.tooltip = text;
                              legend=
                                    '<span style="color:' + textcolor + ';">' + text + '</span>'
                                ;
                            }
                            else {
                                let sigClass = (pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt || Number(changeVal) < 0) ? 'red' : 'black';
                                let text = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '');
                                let changeText = (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA');
                                pointWithMetric.tooltip = text + (textCheck != 'I/S' ? ' (' + changeText + ')' : '');
                               legend= textCheck != 'I/S' ?
                                    '<span style="color:' + textcolor + ';">' + text + '</span>' +
                                    '<span style="font-size:0.75em;color:' + sigClass + ';"> (' + changeText + ')</span>' :
                                    '<span style="color:' + textcolor + ';">' + text + '</span>'
                                ;
                            }
                        }

                        if (chartproperties.datalabelStyle === 'change') {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeText = pointWithMetric.y != null ? getChangeValue(pointWithMetric) : '';
                            pointWithMetric.tooltip = text + (changeText !== '' ? ' (' + changeText + ')' : '');
                           legend=
                                '<span style="color:' + textcolor + ';">' + text + '</span>' +
                                (changeText !== '' ? '<span style="font-size:0.75em;color:' + (chartproperties.darkTheme ? 'white' : 'black') + ';"> (' + changeText + ')</span>' : '')
                            ;
                        }

                        if (chartproperties.datalabelStyle === 'significance + changeVs') {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let sig = Number(pointWithMetric.significance);
                            let s = sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                            let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeText = pointWithMetric.y != null ? getChangeValue(pointWithMetric) : '';
                            pointWithMetric.tooltip = text + (changeText !== '' ? ' (' + changeText + ')' : '') + s;
                          legend=
                                '<span style="color:' + textcolor + ';">' + text + '</span>' +
                                (changeText !== '' ? '<span style="font-size:0.75em;color:' + (chartproperties.darkTheme ? 'white' : 'black') + ';"> (' + changeText + ')</span>' : '') +
                                '<span style="color:' + sigcolor + ';">' + s + '</span>'
                            ;
                        }

                        if (chartproperties.datalabelStyle == 'significance') {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let sig = pointWithMetric.significance;
                            let s = Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                            let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                            let text = pointWithMetric.y != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                            pointWithMetric.tooltip = text;
                           legend=
                                '<span style:"color:' + textcolor + ';">' + text + '</span>'
                            ;
                        }

                        if (chartproperties.datalabelStyle == 'ls') {
                            let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                            pointWithMetric.tooltip = text;
                            legend=
                                '<span style:"color:' + textcolor + ';">' + text + '</span>'
                            ;
                        }

                        if (chartproperties.datalabelStyle == "significance2") {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let text = pointWithMetric.y != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeValue = getChangeValue(pointWithMetric);
                            let changeText = changeValue.toString(); // Convert back to string for display
                            let sig = pointWithMetric.significance;
                            let sig1 = pointWithMetric.significance2;
                            let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                            let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                            let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                            if (changeValue > 0) {
                                changeText = "+" + changeText;
                            }
                            pointWithMetric.tooltip = text + (pointWithMetric.y != null && changeText ? ' (' + changeText + ') ' + s : '');
                           legend=
                                '<span>' + text + '</span>' +
                                (pointWithMetric.y != null && changeText ? '<span style="font-size:0.75em; color:' + changeColor + ';"> (' + changeText + ')</span> <span style="color:' + sColor + ';">' + s + '</span>' : '') +
                                '</span>'
                            ;
                        }

                        // Default fallback - just return the value

                    }

        if (point.color != "#eeebed" && point.color != "#7f7f7f") {
            let legendMarginBottom = (chartproperties.legendPosition === 'left' || chartproperties.legendPosition === 'right') ? (popUpState ? 'margin-bottom:4px;' : 'margin-bottom:2px;') : '';
            let legendMarginLeft = (chartproperties.legendPosition === 'bottom') ? 'margin-left:0.3em;' : '';
            let fontSize = popUpState ? '0.8em' : '0.7em'; // Larger text when popup is true
            let circleSize = popUpState ? '10px' : '9px'; // Larger circle when popup is true
            let marginRight = popUpState ? '8px' : '6px'; // More margin when popup is true
            let maxWidth = popUpState ? '50rem' : '15rem'; // Wider text area when popup is true

           let wrapStyle = '';
   
        wrapStyle = `
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            white-space: normal;
            text-overflow: ellipsis;
            word-break: break-word;
        `;
  

    return '<div style="display:flex;align-items:center;font-size:' + fontSize + ';' + legendMarginBottom + legendMarginLeft + '" title="' + point.name + '">'
        + '<div style="display:flex;width:' + circleSize + ';height:' + circleSize + ';background-color:' + point.color + ';border-radius:50%;margin-right:' + marginRight + ';"></div>'
        + '<div style="width:' + maxWidth + ';font-size:' + fontSize + ';color:' + textcolor + ';' + wrapStyle + 'flex:1;line-height:1.1;" title="' +  point.name + '">' + legend + ' ' + point.name + '</div>'
        + '</div>';
        }
    },
},
        xAxis: {
            tickInterval: 1,
            lineWidth: 0,
            gridLineWidth: 0,
            labels: {
                enabled: false
            }
        },
        yAxis: {
            min: 0,
            max: axisMax,
            gridLineWidth: 0,
            lineWidth: 0,
            tickWidth: 0,
            labels: {
                enabled: false
            }
        },
        plotOptions: {
            column: {
                stacking: 'normal',
                borderWidth: 0,
                pointPadding: 0,
                // Scale ring thickness for up to 6 concentric metrics
                groupPadding: (() => {
                  const ringCount = Math.max(1, Math.min(categories.length, this.getMaxRingCount()));
                  if (this.isMultiCohort) {
                    if (ringCount >= 6) return 0.12;
                    if (ringCount >= 5) return 0.15;
                    if (ringCount >= 4) return 0.18;
                    if (ringCount >= 3) return 0.22;
                    return 0.28;
                  }
                  return this.isOutput ? 0.25 : 0.15;
                })(),
                pointPlacement: 'between',
                       dataLabels: {
               enabled:false,
                allowOverlap: true,
                crop: false,
                overflow: 'allow',
                style: {
                    fontSize: chartproperties.dataLabelSize, // Reduced data label size
                    fontWeight: "bold",
                    borderWidth: 0,
                    borderColor: 'transparent',
                    textOutline: 'none',
                    fontFamily: 'KantarBrown-Regular'
                },
                textPath: {
                    enabled: true,
                    attributes: {
                        textAnchor: 'start',
                        startOffset: 10,
                        dy: 14
                    }
                },
                // enabled: chartproperties.showDataLabel,
                color: chartproperties.dataLabelColor == "default" ? ((chartproperties.datalabelStyle == "bubble" && chartproperties.gradientBarColor && chartproperties.darkTheme) ? 'black' : chartproperties.darkTheme ? 'white' : 'black') : chartproperties.dataLabelColor,
                // border:'none',
                zIndex: 1000,
                formatter: function(this: any): any {
                    // Simple formatter when isOutput is false
                    if (!isOutputFlag) {
                        return this.y || '';
                    }

                    // Comprehensive formatter when isOutput is true
                    // Access the data point properties from this.point or directly from this
                    const dataPoint = this.point || this;
                    const pointWithMetric = {
                        name: dataPoint.name || this.series.name,
                        color: dataPoint.color || this.color,
                        y: dataPoint.y || this.y,
                        y1: dataPoint.y1,
                        cov: dataPoint.cov,
                        significance: dataPoint.significance,
                        samplesize: dataPoint.samplesize,
                        significance2: dataPoint.significance2,
                        tooltip: dataPoint.tooltip,
                        isPercentage: dataPoint.isPercentage,
                        Sig_LowerLimt: dataPoint.Sig_LowerLimt,
                        Sig_UpperLimt: dataPoint.Sig_UpperLimt,
                        Significance_Value: dataPoint.Significance_Value,
                        indexValue: dataPoint.indexValue,
                        actualIndexValue: dataPoint.actualIndexValue
                    };

                    if (this.color !== '#eeebed' && this.color != '#7f7f7f') {
                        chartproperties.dataLabelFormat = pointWithMetric.isPercentage;
                        let textcolor = chartproperties.darkTheme ? 'white' : 'black';

                        if (chartproperties.datalabelStyle == 'datalabel') {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                            pointWithMetric.tooltip = text;
                            return (
                                '<span style="color:' + textcolor + ';">' + text + '</span>'
                            );
                        }

                        if (chartproperties.datalabelStyle === "index") {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));

                            let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';

                            if (text2 == "-1" || text2 == -1) {
                                text2 = "NA";
                            }
                            text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));

                            let color = configService.CheckIndexColoring(String(text2));
                            pointWithMetric.tooltip = text + "(" + text2 + ")";
                            // Smaller font for content inside ()
                            return (
                                '<span style="font-size:0.95em;color:' + textcolor + ';">' + text + '</span>' +
                                '<span style="color:' + color + ';font-size:0.75em;"> (' + text2 + ')</span>'
                            );
                        }

                        if (chartproperties.datalabelStyle === 'sigChange') {
                            let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                            let changeVal = getChangeValue(pointWithMetric);
                            if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                                let text = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' ' + (textCheck != 'I/S' ? '<span style="color:black;font-size:80%;">(NA)</span>' : '');
                                pointWithMetric.tooltip = text;
                                return (
                                    '<span style="color:' + textcolor + ';">' + text + '</span>'
                                );
                            }
                            else {
                                let sigClass = (pointWithMetric.Significance_Value < pointWithMetric.Sig_LowerLimt || Number(changeVal) < 0) ? 'red' : 'black';
                                let valueText = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '');
                                let changeText = (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA');
                                pointWithMetric.tooltip = valueText + (textCheck != 'I/S' ? ' (' + changeText + ')' : '');
                                return (
                                    '<span style="color:' + textcolor + ';">' + valueText + '</span>' +
                                    (textCheck != 'I/S' ? '<span style="font-size:0.75em;color:' + sigClass + ';"> (' + changeText + ')</span>' : '')
                                );
                            }
                        }

                        if (chartproperties.datalabelStyle === 'change') {
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeText = pointWithMetric.y != null ? getChangeValue(pointWithMetric) : '';
                            pointWithMetric.tooltip = text + (changeText !== '' ? ' (' + changeText + ')' : '');
                            return (
                                '<span style="color:' + textcolor + ';">' + text + '</span>' +
                                (changeText !== '' ? '<span style="font-size:0.75em;color:' + (chartproperties.darkTheme ? 'white' : 'black') + ';"> (' + changeText + ')</span>' : '')
                            );
                        }

                        if (chartproperties.datalabelStyle === 'significance + changeVs') {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let sig = Number(pointWithMetric.significance);
                            let s = sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                            let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                            let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeText = pointWithMetric.y != null ? getChangeValue(pointWithMetric) : '';
                            pointWithMetric.tooltip = text + (changeText !== '' ? ' (' + changeText + ')' : '') + s;
                            return (
                                '<span style="color:' + textcolor + ';">' + text + '</span>' +
                                (changeText !== '' ? '<span style="font-size:0.75em;color:' + (chartproperties.darkTheme ? 'white' : 'black') + ';"> (' + changeText + ')</span>' : '') +
                                '<span style="color:' + sigcolor + ';">' + s + '</span>'
                            );
                        }

                        if (chartproperties.datalabelStyle == 'significance') {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let sig = pointWithMetric.significance;
                            let s = Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                            let sigcolor = Number(sig) > 0 ? 'green' : Number(sig) < 0 ? 'red' : '';
                            let text = pointWithMetric.y != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + '<span style="color:' + sigcolor + ';">' + s + '</span>') : 'NA';
                            pointWithMetric.tooltip = text;
                            return (
                                '<span style:"color:' + textcolor + ';">' + text + '</span>'
                            );
                        }

                        if (chartproperties.datalabelStyle == 'ls') {
                            let text = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                            pointWithMetric.tooltip = text;
                            return (
                                '<span style:"color:' + textcolor + ';">' + text + '</span>'
                            );
                        }

                        if (chartproperties.datalabelStyle == "significance2") {
                            const upwardTriangle = '\u25B2';
                            const downwardTriangle = '\u25BC';
                            let text = pointWithMetric.y != null ? this.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                            let changeValue = getChangeValue(pointWithMetric);
                            let changeText = changeValue.toString(); // Convert back to string for display
                            let sig = pointWithMetric.significance;
                            let sig1 = pointWithMetric.significance2;
                            let sColor = Number(sig) > 0 ? 'green' : (Number(sig) < 0 ? 'red' : '');
                            let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                            let changeColor = sig1 < 0 ? 'red' : (sig1 > 0 ? 'green' : (chartproperties.darkTheme ? 'white' : 'black'));

                            if (changeValue > 0) {
                                changeText = "+" + changeText;
                            }
                            pointWithMetric.tooltip = text + (pointWithMetric.y != null && changeText ? ' (' + changeText + ') ' + s : '');
                            return (
                                '<span>' + text + '</span>' +
                                (pointWithMetric.y != null && changeText ? '<span style="font-size:0.75em; color:' + changeColor + ';"> (' + changeText + ')</span> <span style="color:' + sColor + ';">' + s + '</span>' : '') +
                                '</span>'
                            );
                        }

                        // Default fallback - just return the value
                        return this.y || '';
                    } else {
                        return null;
                    }
                }
            },
            }
        },
        tooltip: {
            enabled: true,
            borderWidth: 1,
            useHTML: true,
            shape: 'rect',
            shadow: false,
            backgroundColor: 'white',
          outside: !popUpState,
            style: {
                fontSize: '0.8rem',
                fontFamily:'KantarBrown-Regular',
            },
            formatter: function (this: any): any {
                const dataPoint = this.point;
                const pointWithMetric = {
                    name: dataPoint.name || this.series.name,
                    color: dataPoint.color || this.color,
                    y: dataPoint.y || this.y,
                    y1: dataPoint.y1,
                    cov: dataPoint.cov,
                    significance: dataPoint.significance,
                    samplesize: dataPoint.samplesize,
                    significance2: dataPoint.significance2,
                    tooltip: dataPoint.tooltip,
                    isPercentage: dataPoint.isPercentage,
                    Sig_LowerLimt: dataPoint.Sig_LowerLimt,
                    Sig_UpperLimt: dataPoint.Sig_UpperLimt,
                    Significance_Value: dataPoint.Significance_Value,
                    indexValue: dataPoint.indexValue,
                    actualIndexValue: dataPoint.actualIndexValue
                };

            if (pointWithMetric.color === '#eeebed' || pointWithMetric.color === '#7f7f7f') { return false };

            const backgroundcolor = chartproperties.darkTheme ? '#b3b3b3' : '#f5f5f5';
            const backgroundcolor2 = chartproperties.darkTheme ? '#dddddd' : 'white';
                const dotColor = pointWithMetric.color;

            // Generate tooltip text using the same logic as data labels
                let tooltipText = '';

                if (!isOutputFlag) {
                // Simple tooltip when isOutput is false
                    tooltipText = pointWithMetric.y || '';
                } else {
                // Use same logic as data label formatter
                chartproperties.dataLabelFormat = pointWithMetric.isPercentage;

                if (chartproperties.datalabelStyle == 'datalabel') {
                    let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    tooltipText = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                }
                else if (chartproperties.datalabelStyle === "index") {
                    let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    text = configService.CheckLSorIScondition(configService.userRole, text, Number(pointWithMetric.samplesize));
                    let text2 = pointWithMetric.actualIndexValue == null ? 'NA' : pointWithMetric.y == -1 ? -1 : pointWithMetric.y != null ? pointWithMetric.indexValue.toFixed(1) : 'NA';
                    if (text2 == "-1" || text2 == -1) {
                        text2 = "NA";
                    }
                    text2 = configService.CheckLSorIScondition(configService.userRole, String(text2), Number(pointWithMetric.samplesize));
                    tooltipText = text + "(" + text2 + ")";
                }
                else if (chartproperties.datalabelStyle === 'sigChange') {
                    let textCheck = configService.CheckLSorIScondition(configService.userRole, String(pointWithMetric.y), Number(pointWithMetric.samplesize));
                    let changeVal = getChangeValue(pointWithMetric);
                    if (pointWithMetric.cov == null || pointWithMetric.cov == 'NA') {
                        tooltipText = textCheck + (chartproperties.dataLabelFormat ? '%' : '') + ' (NA)';
                    } else {
                        tooltipText = textCheck + ((chartproperties.dataLabelFormat && textCheck != 'I/S') ? '%' : '') + ' (' + (pointWithMetric.cov != null ? parseFloat(Number(changeVal).toFixed(1)) + (chartproperties.dataLabelFormat ? '%' : '') : 'NA') + ')';
                    }
                }
                else if (chartproperties.datalabelStyle === 'change') {
                    tooltipText = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' (' + getChangeValue(pointWithMetric) + ')' : 'NA';
                }
                else if (chartproperties.datalabelStyle === 'significance + changeVs') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = Number(pointWithMetric.significance);
                    let s = sig > 0 ? upwardTriangle : sig < 0 ? downwardTriangle : '';
                    tooltipText = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + ' (' + getChangeValue(pointWithMetric) + ')' + s : 'NA';
                }
                else if (chartproperties.datalabelStyle == 'significance') {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let sig = pointWithMetric.significance;
                    let s = Number(sig) > 0 ? upwardTriangle : Number(sig) < 0 ? downwardTriangle : '';
                    tooltipText = pointWithMetric.y != null ? (pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') + s) : 'NA';
                }
                else if (chartproperties.datalabelStyle == 'ls') {
                    tooltipText = Number(pointWithMetric.samplesize) > samplesizeconstant ? (pointWithMetric.y == null ? 'NA' : pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '')) : 'LS';
                }
                else if (chartproperties.datalabelStyle == "significance2") {
                    const upwardTriangle = '\u25B2';
                    const downwardTriangle = '\u25BC';
                    let text = pointWithMetric.y != null ? pointWithMetric.y + (chartproperties.dataLabelFormat ? '%' : '') : 'NA';
                    let changeValue = getChangeValue(pointWithMetric);
                    let changeText = changeValue.toString();
                    let sig = pointWithMetric.significance;
                    let s = Number(sig) > 0 ? upwardTriangle : (Number(sig) < 0 ? downwardTriangle : '');
                    if (changeValue > 0) {
                        changeText = "+" + changeText;
                    }
                    tooltipText = text + (pointWithMetric.y != null && changeText ? ' (' + changeText + ') ' + s : '');
                }
                else {
                    // Default fallback
                    tooltipText = pointWithMetric.y || '';
                }
            }

            let isDefaultTooltip = chartproperties.toolTipStyle;
            if (isDefaultTooltip == "style1") {
             const content =
    `<div class="high-z-tooltip" style="background: #fff;  min-width: 20px; font-size: 0.8em; display: flex; box-shadow: none;align-items: center;z-index:999 !important;padding:2px;">
      <span style=" width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.series.name}: </span>
      <b style="margin-left:4px;">${tooltipText}</b>
    </div>`;
  return content;
            }
            else {
                const commonContent =
                `<div style="border-left: 2px solid ` + dotColor + `;font-size:0.7em; border-bottom: 2px solid ` + dotColor + `; z-index: 100; padding: 5px; border-radius: 5px; margin: 0px; background-color :${backgroundcolor2};">` +
                ` ${pointWithMetric.name} : ` +
                `${tooltipText}`;
              return commonContent + '</div>';
            }
          }
          },
        series: series
    };

    const containerEl = document.getElementById(containerId);
    if (!containerEl) {
      return;
    }
    // Destroy existing chart in this container to prevent duplicate charts on re-render.
    const existingChartRef = this.chartRegistry.get(containerId);
    if (existingChartRef) {
      existingChartRef.destroy();
      this.chartRegistry.delete(containerId);
    }
    this.chart = Highcharts.chart(containerEl, chartOptions);
    this.chartRegistry.set(containerId, this.chart);
}







  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();

    const legendContainer = document.getElementById('popup-legend-table-container-' + this.id);
    if (legendContainer && this.legendTableClickHandler) {
      legendContainer.removeEventListener('click', this.legendTableClickHandler);
      this.legendTableClickHandler = undefined;
    }

    this.chartRegistry.forEach((chartRef: any) => {
      if (chartRef) chartRef.destroy();
    });
    this.chartRegistry.clear();
    this.chart = null;
  }
}


